export default "__VITE_ASSET__lTR1yBfM__"